<template>
  <nav ref="sidebarRoot" :dir="isRtl === true ? 'rtl' : 'ltr'" :class="isRtl === true ? 'sidebar sidebar-rtl bg-white dark:bg-gray-800' : 'sidebar sidebar-ltr bg-white dark:bg-gray-800'">
    <div class="sidebar-head p-4 flex items-center justify-center items-center">
      <router-link to="/" exact class="flex flex-center sidebar-brand-link" style="align-items: center;">
        <div class="sidebar-brand-frame">
          <div v-if="showLogoSkeleton === true" class="sidebar-brand-skeleton"></div>
          <img :key="'sidebar-brand-logo-' + String(logoReloadKey)" :src="displayLogoSrc" alt="Logo" :class="showLogoSkeleton === true ? 'sidebar-brand-image sidebar-brand-image-hidden' : 'sidebar-brand-image'" @load="handleLogoLoad" @error="handleLogoError">
        </div>
      </router-link>
      <div class="bg-gray-700 absolute mt-3 dark:block hidden rounded-md py-1 px-2 text-xs text-gray-200 text-right" data-translate="sidebar.darkMode">
        מצב כהה
      </div>
      <button class="lg:hidden block dark:text-gray-400 float-right -mt-7" @click="$emit('sidebarToggle')">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="25px" height="25px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32">
          <path fill="currentColor" d="M7.219 5.781L5.78 7.22L14.563 16L5.78 24.781l1.44 1.439L16 17.437l8.781 8.782l1.438-1.438L17.437 16l8.782-8.781L24.78 5.78L16 14.563z" />
        </svg>
      </button>
    </div>
    <div class="sidebar-list p-4 divide-y dark:divide-gray-700">
      <div class="pb-5">
        <div class="wrap-item mt-4">
          <div class="item" id="sidebar-item-dashboard-wrapper">
            <router-link to="/" exact class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
              <span class="ml-3 text-xl">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M4 13h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1m-1 7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1zm10 0a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1zm1-10h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1" />
                </svg>
              </span>
              <span class="w-full text-right" data-translate="sidebar.dashboard">לוח מחוונים</span>
            </router-link>
          </div>
        </div>
      </div>
      <div v-if="isAgentEditor === false" class="pb-5" id="sidebar-section-marketplace">
        <div class="item mt-5" id="sidebar-item-marketplace">
          <router-link :to="{ name: 'integrationsHome' }" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <circle cx="7" cy="7" r="3" />
                  <circle cx="17" cy="7" r="3" />
                  <circle cx="7" cy="17" r="3" />
                  <circle cx="17" cy="17" r="3" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.integrationsTitle">Integrations</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-organization-usage">
          <router-link to="/organizationUsage" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M12 3v9h9" />
                  <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right font-semibold" data-translate="sidebar.organizationUsage">Usage</span>
          </router-link>
        </div>
      </div>
      <div class="mb-4" id="sidebar-section-ai-agents">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.aiAgentsTitle">סוכני AI</p>
        <div class="item mt-3" id="sidebar-item-ai-chat-agents">
          <router-link to="/aiChatAgents" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M12 8V4H8" />
                  <rect width="16" height="12" x="4" y="8" rx="2" />
                  <path d="M2 14h2m16 0h2m-7-1v2m-6-2v2" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.aiChatAgents">סוכני צ''אט AI</span>
          </router-link>
        </div>
        <div v-if="isAgentEditor === false" class="item mt-3" id="sidebar-item-ai-agent-tools">
          <router-link to="/aiAgentsTools" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="m13 11l5-5" />
                  <path stroke-linejoin="round" d="m19 7l-2-2l2.5-1.5l1 1zM4.025 8.975a3.5 3.5 0 0 1-.79-3.74l1.422 1.422h2v-2L5.235 3.235a3.5 3.5 0 0 1 4.529 4.53l6.47 6.471a3.5 3.5 0 0 1 4.53 4.529l-1.421-1.422h-2v2l1.422 1.422a3.5 3.5 0 0 1-4.53-4.528L7.763 9.765a3.5 3.5 0 0 1-3.738-.79Z" />
                  <path stroke-linejoin="round" d="m12.203 14.5l-5.604 5.604a1.35 1.35 0 0 1-1.911 0l-.792-.792a1.35 1.35 0 0 1 0-1.911L9.5 11.797" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.aiAgentTools">כלי סוכני AI</span>
          </router-link>
        </div>
        <div v-if="isAgentEditor === false" class="item mt-3" id="sidebar-item-ai-agents-styling">
          <router-link to="/aiAgentsStyling" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M12 21a9 9 0 0 1 0-18c4.97 0 9 3.582 9 8c0 1.06-.474 2.078-1.318 2.828S17.693 15 16.5 15H14a2 2 0 0 0-1 3.75A1.3 1.3 0 0 1 12 21" />
                  <path d="M7.5 10.5a1 1 0 1 0 2 0a1 1 0 1 0-2 0m4-3a1 1 0 1 0 2 0a1 1 0 1 0-2 0m4 3a1 1 0 1 0 2 0a1 1 0 1 0-2 0" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.aiAgentsStyling">עיצוב סוכני AI</span>
          </router-link>
        </div>
        <div v-if="isAgentEditor === false" class="item mt-3" id="sidebar-item-shared-knowledge-bases">
          <router-link to="/sharedKnowledgeBases" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12 8a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m0 3.54C9.64 9.35 6.5 8 3 8v11c3.5 0 6.64 1.35 9 3.54c2.36-2.19 5.5-3.54 9-3.54V8c-3.5 0-6.64 1.35-9 3.54" />
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.knowledgeBaseTitle">מאגרי ידע שיתופיים</span>
          </router-link>
        </div>
        <div v-if="isAgentEditor === false" class="item mt-3" id="sidebar-item-terms-packages">
          <router-link to="/termsPackages" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="26px" height="26px" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
                  <path d="M8 7h6m-6 4h8" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.termsPackages">חבילות מונחים</span>
          </router-link>
        </div>
        <div v-if="isAgentEditor === false" class="item mt-3" id="sidebar-item-communication-sources">
          <router-link to="/communicationSources" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 14 14">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12.512 7.463a6 6 0 1 1-6-6m-6 6h6.923" />
                  <path d="M6.512 1.463a10.36 10.36 0 0 0-2.308 6a10.36 10.36 0 0 0 2.308 6a10.36 10.36 0 0 0 2.142-4.615" />
                  <path d="M7.404 3.97c-.35-.06-.35-.564 0-.625A3.18 3.18 0 0 0 9.963.895l.02-.097c.077-.347.57-.35.65-.003l.025.113a3.19 3.19 0 0 0 2.566 2.435c.353.061.353.568 0 .63a3.19 3.19 0 0 0-2.566 2.435l-.025.112c-.08.346-.573.344-.65-.003l-.02-.096a3.18 3.18 0 0 0-2.559-2.45" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.communicationSources">מקורות תקשורת</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-agent-evals">
          <router-link id="sidebar-agent-evals-button" to="/agentEvals" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
                  <path d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2m0 9l2 2l4-4" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.agentEvals">בדיקות סוכן</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-voice-playground">
          <router-link to="/voicePlayground" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="26px" height="26px" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M12 3a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3Z" />
                  <path d="M19 10v1a7 7 0 0 1-14 0v-1m7 8v3m-4 0h8" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.voicePlayground">Voice Playground</span>
          </router-link>
        </div>
      </div>
      <div class="mb-4" id="sidebar-section-workflows">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.workflows">Workflows</p>
        <div class="item mt-3" id="sidebar-item-workflows-main">
          <router-link to="/workflows" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7a2 2 0 1 0 4 0a2 2 0 1 0-4 0m11 8a2 2 0 1 0 4 0a2 2 0 1 0-4 0m1-9a3 3 0 1 0 6 0a3 3 0 1 0-6 0M3 18a3 3 0 1 0 6 0a3 3 0 1 0-6 0m6-1l5-1.5m-7.5-7l7.81 5.37M7 7l8-1" />
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.workflows">Workflows</span>
          </router-link>
        </div>
      </div>
      <div v-if="isAgentEditor === false" class="mb-4" id="sidebar-section-campaigns">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.campaignsTitle">קמפיינים</p>
        <div class="item mt-3" id="sidebar-item-campaigns">
          <router-link to="/campaigns" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M3 11l18-5v12L3 14v-3z" />
                  <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.campaigns">קמפיינים</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-campaign-reports">
          <router-link to="/reports?type=campaigns" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="26px" height="26px" viewBox="0 0 24 24">
                <g fill="currentColor">
                  <rect width="5" height="18" x="16" y="3" rx="2" />
                  <rect width="5" height="12" x="9.5" y="9" rx="2" />
                  <rect width="5" height="5" x="3" y="16" rx="2" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.campaignReports">דוחות קמפיינים</span>
          </router-link>
        </div>
      </div>
      <div v-if="isAgentEditor === false" class="mb-4" id="sidebar-section-reports-and-analysis">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.reportsTitle">דוחות</p>
        <div class="item mt-3" id="sidebar-item-deep-analysis">
          <router-link to="/reportDashboards" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32">
                <path fill="currentColor" d="M4 20v2h4.586L2 28.586L3.414 30L10 23.414V28h2v-8zm20 1h2v5h-2zm-4-5h2v10h-2zm-4 2h2v8h-2z" />
                <path fill="currentColor" d="M28 2H4a2 2 0 0 0-2 2v12h2v-3h24.001l.001 15H16v2h12a2.003 2.003 0 0 0 2-2V4a2 2 0 0 0-2-2m-16 9H4V4h8Zm2 0V4h14v7Z" />
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.deepAnalysis">ניתוח מעמיק</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-reports">
          <router-link to="/reports" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="currentColor">
                  <rect width="5" height="18" x="16" y="3" rx="2" />
                  <rect width="5" height="12" x="9.5" y="9" rx="2" />
                  <rect width="5" height="5" x="3" y="16" rx="2" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.reportsLink">דוחות</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-analysis-engine">
          <router-link to="/analysisEngine" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="26px" height="26px" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M15.5 13a3.5 3.5 0 0 0-3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1-7 0v-1.8" />
                  <path d="M17.5 16a3.5 3.5 0 0 0 0-7H17" />
                  <path d="M19 9.3V6.5a3.5 3.5 0 0 0-7 0M6.5 16a3.5 3.5 0 0 1 0-7H7" />
                  <path d="M5 9.3V6.5a3.5 3.5 0 0 1 7 0v10" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.analysisEngine">Analysis Engine</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-custom-reports">
          <router-link to="/customReports" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="26px" height="26px" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <path d="M14 2v6h6M8 18v-2m4 2v-4m4 4v-6" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.customReports">Custom Reports</span>
          </router-link>
        </div>
        <div class="item mt-3 hidden" id="sidebar-item-token-usage">
          <router-link to="/tokenUsage" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 13a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm12-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM9 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM4 20h14" />
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.tokenUsage"> Token Usage </span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-unanswered-questions">
          <router-link to="/unansweredQuestions" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9h8m-8 4h6m0 5h-1l-5 3v-3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v4.5M19 22v.01M19 19a2.003 2.003 0 0 0 .914-3.782a1.98 1.98 0 0 0-2.414.483" />
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.unansweredQuestions">שאלות ללא מענה</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-live-sessions">
          <router-link to="/liveSessions" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M18.364 19.364a9 9 0 1 0-12.728 0" />
                  <path d="M15.536 16.536a5 5 0 1 0-7.072 0" />
                  <path d="M11 13a1 1 0 1 0 2 0a1 1 0 1 0-2 0" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.liveSessions">שיחות פעילות</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-tags">
          <router-link to="/tags" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M3 8v4.172a2 2 0 0 0 .586 1.414l5.71 5.71a2.41 2.41 0 0 0 3.408 0l3.592-3.592a2.41 2.41 0 0 0 0-3.408l-5.71-5.71A2 2 0 0 0 9.172 6H5a2 2 0 0 0-2 2" />
                  <path d="m18 19l1.592-1.592a4.82 4.82 0 0 0 0-6.816L15 6m-8 4h-.01" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.tags">תגיות</span>
          </router-link>
        </div>
      </div>
      <div v-if="isAgentEditor === false" class="mb-4" id="sidebar-section-applications-platform">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.applicationsPlatformTitle">פלטפורמת יישומים</p>
        <div class="item mt-3" id="sidebar-item-applications">
          <router-link to="/applications" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm0 10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm10 0a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm0-8h6m-3-3v6" />
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.applications">יישומים</span>
          </router-link>
        </div>
      </div>
      <div v-if="isAgentEditor === false" class="mb-4" id="sidebar-section-configurations">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.configurationsTitle">תצורות</p>
        <div class="item mt-3 hidden" id="sidebar-item-services-settings">
          <router-link to="/aiServicesConfig" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32">
                <path fill="currentColor" d="m22.505 11.637l-5.989-3.5a1 1 0 0 0-1.008-.001l-6.011 3.5A1 1 0 0 0 9 12.5v7a1 1 0 0 0 .497.864l6.011 3.5A.96.96 0 0 0 16 24c.174 0 .36-.045.516-.137l5.989-3.5A1 1 0 0 0 23 19.5v-7a1 1 0 0 0-.495-.863m-6.494-1.48l4.007 2.343l-4.007 2.342l-4.023-2.342zM11 14.24l4 2.33v4.685l-4-2.33zm6 7.025v-4.683l4-2.338v4.683z" />
                <path fill="currentColor" d="M16 1a1 1 0 0 0-.504.136l-12 7A1 1 0 0 0 3 9v14a1 1 0 0 0 .496.864l12 7a1 1 0 0 0 1.008 0l11-6.417l-1.008-1.727L16 28.842L5 22.426V9.575l11-6.417l11 6.416V17h2V9a1 1 0 0 0-.496-.864l-12-7A1 1 0 0 0 16 1" />
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.servicesSettings">הגדרות שירותים</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-api-keys">
          <router-link to="/organizationApiKeys" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
                  <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.apiKeys">מפתחות API</span>
          </router-link>
        </div>
        <div v-if="canViewApiDocs === true" class="item mt-3" id="sidebar-item-api-documentation">
          <router-link to="/documentation" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <path fill="currentColor" d="M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3M5 8V5c0-.805.55-.988 1-1h13v12H5z" />
                <path fill="currentColor" d="M8 6h9v2H8z" />
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.apiDocumentation">תיעוד API</span>
          </router-link>
        </div>
      </div>
      <div class="mb-4 hidden" id="sidebar-section-infrastructure">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.infrastructureTitle">תשתיות</p>
        <div class="item mt-3" id="sidebar-item-health-check">
          <router-link to="/healthCheck" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="mr-2" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none">
                  <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M18.5 9h-2m0 0h-2m2 0V7m0 2v2" />
                  <path fill="currentColor" d="m8.962 19.379l.472-.583zM12 5.574l-.548.512a.75.75 0 0 0 1.096 0zm3.038 13.805l.473.582zM12 21v-.75zm-9.348-7.318a.75.75 0 1 0 1.283-.776zm3.885 2.489a.75.75 0 1 0-1.074 1.046zM2.75 9.318c0-2.905 1.268-4.7 2.836-5.315c1.565-.613 3.754-.175 5.866 2.083l1.096-1.024c-2.388-2.554-5.199-3.36-7.509-2.456C2.732 3.51 1.25 5.992 1.25 9.318zM15.51 19.96c1.493-1.211 3.281-2.834 4.703-4.647c1.407-1.794 2.537-3.879 2.537-5.997h-1.5c0 1.612-.88 3.364-2.218 5.071c-1.324 1.689-3.016 3.232-4.466 4.408zm7.24-10.644c0-3.325-1.482-5.807-3.79-6.71c-2.31-.905-5.12-.1-7.508 2.455l1.096 1.024c2.112-2.258 4.301-2.696 5.866-2.083c1.568.614 2.836 2.41 2.836 5.314zM8.49 19.961c1.27 1.032 2.152 1.789 3.51 1.789v-1.5c-.723 0-1.173-.324-2.566-1.454zm6.076-1.165c-1.393 1.13-1.843 1.454-2.566 1.454v1.5c1.358 0 2.24-.757 3.51-1.789zm-10.63-5.89C3.187 11.67 2.75 10.455 2.75 9.318h-1.5c0 1.512.576 3 1.402 4.364zm5.498 5.89a34 34 0 0 1-2.897-2.625l-1.074 1.046a35 35 0 0 0 3.026 2.744z" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.healthCheck">בדיקת תקינות</span>
          </router-link>
        </div>
      </div>
      <div v-if="isAgentEditor === false" class="mb-4" id="sidebar-section-security">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.securityTitle">אבטחה</p>
        <div class="item mt-3" id="sidebar-item-allowed-origins">
          <router-link to="/security" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M12 3a12 12 0 0 0 8.5 3A12 12 0 0 1 12 21A12 12 0 0 1 3.5 6A12 12 0 0 0 12 3" />
                  <path d="M11 11a1 1 0 1 0 2 0a1 1 0 1 0-2 0m1 1v2.5" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.allowedOrigins">מקורות מורשים</span>
          </router-link>
        </div>
      </div>
      <div v-if="isAgentEditor === false" class="pb-5">
        <p class="font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.organizationSettingsTitle">הגדרות ארגון</p>
        <div class="item mt-3" id="sidebar-item-organization">
          <router-link to="/organizationSettings" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="1.5">
                  <circle cx="12" cy="12" r="3" />
                  <path d="M13.765 2.152C13.398 2 12.932 2 12 2s-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083c-.092.223-.129.484-.143.863a1.62 1.62 0 0 1-.79 1.353a1.62 1.62 0 0 1-1.567.008c-.336-.178-.579-.276-.82-.308a2 2 0 0 0-1.478.396C4.04 5.79 3.806 6.193 3.34 7s-.7 1.21-.751 1.605a2 2 0 0 0 .396 1.479c.148.192.355.353.676.555c.473.297.777.803.777 1.361s-.304 1.064-.777 1.36c-.321.203-.529.364-.676.556a2 2 0 0 0-.396 1.479c.052.394.285.798.75 1.605c.467.807.7 1.21 1.015 1.453a2 2 0 0 0 1.479.396c.24-.032.483-.13.819-.308a1.62 1.62 0 0 1 1.567.008c.483.28.77.795.79 1.353c.014.38.05.64.143.863a2 2 0 0 0 1.083 1.083C10.602 22 11.068 22 12 22s1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083c.092-.223.129-.483.143-.863c.02-.558.307-1.074.79-1.353a1.62 1.62 0 0 1 1.567-.008c.336.178.579.276.819.308a2 2 0 0 0 1.479-.396c.315-.242.548-.646 1.014-1.453s.7-1.21.751-1.605a2 2 0 0 0-.396-1.479c-.148-.192-.355-.353-.676-.555A1.62 1.62 0 0 1 19.562 12c0-.558.304-1.064.777-1.36c.321-.203.529-.364.676-.556a2 2 0 0 0 .396-1.479c-.052-.394-.285-.798-.75-1.605c-.467-.807-.7-1.21-1.015-1.453a2 2 0 0 0-1.479-.396c-.24.032-.483.13-.82.308a1.62 1.62 0 0 1-1.566-.008a1.62 1.62 0 0 1-.79-1.353c-.014-.38-.05-.64-.143-.863a2 2 0 0 0-1.083-1.083Z" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.organizationLink">ארגון</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-divisions">
          <router-link to="/divisions" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none">
                  <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                  <path fill="currentColor" d="M13 13a4 4 0 0 1 4 4v1.5a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 2 18.5V17a4 4 0 0 1 4-4zm6 0a3 3 0 0 1 3 3v1.5a1.5 1.5 0 0 1-1.5 1.5H19v-2a5 5 0 0 0-2-4zM9.5 3a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9M18 6a3 3 0 1 1 0 6a3 3 0 0 1 0-6" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.divisions">חטיבות</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-users">
          <router-link to="/users" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M3 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z" />
                  <path d="M7 10a2 2 0 1 0 4 0a2 2 0 1 0-4 0m8-2h2m-2 4h2M7 16h10" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.users">משתמשים</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-roles">
          <router-link to="/roles" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M12 3a12 12 0 0 0 8.5 3A12 12 0 0 1 12 21A12 12 0 0 1 3.5 6A12 12 0 0 0 12 3" />
                  <path d="M11 11a1 1 0 1 0 2 0a1 1 0 1 0-2 0m1 1v2.5" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.roles">תפקידים</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-auditLogs">
          <router-link to="/auditLogs" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5">
                  <path stroke-linejoin="round" d="M19 10.5V10c0-3.771 0-5.657-1.172-6.828S14.771 2 11 2S5.343 2 4.172 3.172S3 6.229 3 10v6c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C6.204 22 7.136 22 9 22" />
                  <path d="M7 7h8m-8 4h4" />
                  <path stroke-linejoin="round" d="M15.283 19.004c-.06-.888-.165-1.838-.601-2.912c-.373-.916-.269-3.071 1.818-3.071s2.166 2.155 1.794 3.07c-.436 1.075-.518 2.025-.576 2.913M21 22h-9v-1.246c0-.446.266-.839.653-.961l2.255-.716q.242-.077.494-.077h2.196q.252 0 .494.077l2.255.716c.387.122.653.515.653.961z" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.auditlogs">ביקורת שימושיות</span>
          </router-link>
        </div>
      </div>
      <div class="mb-4" id="sidebar-section-quality-assurance">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.qualityAssurance">בקרת איכות</p>
        <div class="item mt-3" id="sidebar-item-pdf-qa">
          <router-link to="/qa/file-processing" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                  <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2M9 9h1m-1 4h6m-6 4h6" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.pdfQa">File Processing Preview</span>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-scrape-test">
          <router-link to="/scarpe/website/test" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0-18 0m.6-3h16.8M3.6 15h16.8" />
                  <path d="M11.5 3a17 17 0 0 0 0 18m1-18a17 17 0 0 1 0 18" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="sidebar.scrapeWebsiteTest">בדיקת גרירת אתר</span>
          </router-link>
        </div>
      </div>
      <div v-if="isAgentEditor === false" class="mb-4" id="sidebar-section-entities">
        <p class="pt-2 font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.entitiesTitle">Entities</p>
        <div class="item mt-3" id="sidebar-item-entities">
          <router-link :to="{ path: '/entities' }" custom v-slot="{ href, navigate }">
            <a :href="href" :class="['nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse', currentEntitiesTab === 'entities' ? 'exact-active' : '']" @click="navigate">
              <span class="ml-3 text-xl">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="26px" height="26px" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                    <path d="M12 11a4 4 0 1 0-4-4a4 4 0 0 0 4 4" />
                    <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    <path d="M21 21v-2a4 4 0 0 0-3-3.87" />
                  </g>
                </svg>
              </span>
              <span class="w-full text-right" data-translate="sidebar.entities">Entities</span>
            </a>
          </router-link>
        </div>
        <div class="item mt-3" id="sidebar-item-entity-collections">
          <router-link :to="{ path: '/entities', query: { tab: 'collections' } }" custom v-slot="{ href, navigate }">
            <a :href="href" :class="['nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse', currentEntitiesTab === 'collections' ? 'exact-active' : '']" @click="navigate">
              <span class="ml-3 text-xl">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="26px" height="26px" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                    <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <path d="M8 13h8" />
                  </g>
                </svg>
              </span>
              <span class="w-full text-right" data-translate="sidebar.entityCollections">Entity Collections</span>
            </a>
          </router-link>
        </div>
      </div>
      <div v-if="isAgentEditor === false" class="pb-5">
        <p class="font-medium text-gray-400 mt-4 dark:text-gray-400 text-right" data-translate="sidebar.integrationsTitle">אינטגרציות</p>
        <div class="item mt-3" id="sidebar-item-third-party-integrations">
          <router-link :to="{ name: 'thirdPartyIntegrations' }" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse">
            <span class="ml-3 text-xl"></span>
            <span class="w-full text-right" data-translate="sidebar.thirdPartyIntegrations">אינטגרציות צד שלישי</span>
          </router-link>
        </div>
        <div class="item mt-3 hidden" id="sidebar-item-logout">
          <a href="#" class="nav-link w-full flex rounded-xl box-border p-3 flex-row-reverse" @click.prevent="logout">
            <span class="ml-3 text-xl">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="26px" height="26px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path d="M14 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2" />
                  <path d="M9 12h12l-3-3m0 6l3-3" />
                </g>
              </svg>
            </span>
            <span class="w-full text-right" data-translate="header.signOut">התנתקו</span>
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, onMounted, watch, nextTick, computed } from 'vue';
import { applyVendorBrandingFromCurrentOrigin, globalState } from '@/globalState';
import { useI18n, applyTranslationsToDOM } from '@/i18n';
import { useRoute, useRouter } from 'vue-router';
import { getLogger } from '@/shared/tools/logService.js';

const { currentLanguage } = useI18n();
const log = getLogger('Sidebar.vue');
const sidebarRoot = ref(null);
const route = useRoute();
const router = useRouter();
const userPermissions = ref([]);
const userRoles = ref([]);
const isRtl = computed(() => currentLanguage.value === 'he' || currentLanguage.value === 'ar');
const currentEntitiesTab = computed(() => {
  if (route.path !== '/entities') {
    return '';
  }
  const routeTab = typeof route.query?.tab === 'string' ? route.query.tab.trim().toLowerCase() : '';
  if (routeTab === 'collections') {
    return 'collections';
  }
  return 'entities';
});
const canViewApiDocs = computed(() => {
  return userPermissions.value.includes('fullAccessToOrganization') === true || userPermissions.value.includes('viewApiDocs') === true;
});
const isAgentEditor = computed(() => {
  return userRoles.value.some(r => typeof r === 'string' && r.trim().toLowerCase() === 'agent editor') === true;
});
const logout = () => {
  const sameSiteLax = (process.env.environment === 'production') ? '; SameSite=Lax' : '';
  document.cookie = `authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
  document.cookie = `jwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
  document.cookie = `orgSettings=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
  router.push('/login');
};

const logoLoaded = ref(false);
const logoLoadFailed = ref(false);
const logoReloadKey = ref(0);
const brandLogoSrc = computed(() => {
  const rawLogo = globalState.whitelabel !== undefined && globalState.whitelabel !== null ? globalState.whitelabel.logoUrl : null;
  if (typeof rawLogo !== 'string') {
    return '';
  }
  const trimmedLogo = rawLogo.trim();
  if (trimmedLogo === '' || trimmedLogo === '/logo.svg') {
    return '';
  }
  return trimmedLogo;
});
const shouldUseBrandLogo = computed(() => {
  const brandingEnabled = globalState.whitelabel !== undefined && globalState.whitelabel !== null ? globalState.whitelabel.enabled : undefined;
  return brandLogoSrc.value !== '' && brandingEnabled !== false;
});
const displayLogoSrc = computed(() => {
  if (shouldUseBrandLogo.value === true && logoLoadFailed.value !== true) {
    return brandLogoSrc.value;
  }
  return '/logo.svg?r=' + String(logoReloadKey.value);
});
const showLogoSkeleton = computed(() => shouldUseBrandLogo.value === true && logoLoaded.value !== true && logoLoadFailed.value !== true);

function handleLogoLoad() {
  logoLoaded.value = true;
}

function handleLogoError() {
  if (shouldUseBrandLogo.value === true && displayLogoSrc.value === brandLogoSrc.value) {
    logoLoadFailed.value = true;
    logoLoaded.value = false;
    return;
  }
  logoLoaded.value = true;
}

function getUserPermissionsFromCookies() {
  try {
    if (typeof document === 'undefined') {
      return [];
    }
    if (globalState.authUsesHttpOnlyCookies !== true) {
      const authCookie = document.cookie.split('; ').find(row => row.startsWith('authToken=') != false);
      const jwtCookie = document.cookie.split('; ').find(row => row.startsWith('jwtToken=') != false);
      const tokenCookie = authCookie !== undefined && authCookie !== null ? authCookie : jwtCookie;
      if (tokenCookie !== undefined && tokenCookie !== null) {
        const token = tokenCookie.split('=')[1];
        if (token !== undefined && token !== null && token !== '') {
          try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            if (Array.isArray(payload.permissions) === true) {
              return payload.permissions;
            }
          } catch (e1) {}
        }
      }
    }
    const userDataCookie = document.cookie.split('; ').find(row => row.startsWith('userData=') != false);
    if (userDataCookie !== undefined) {
      const cookieValue = userDataCookie.split('=')[1];
      if (cookieValue !== undefined && cookieValue !== null && cookieValue !== '') {
        try {
          const decodedValue = decodeURIComponent(cookieValue);
          if (decodedValue !== 'undefined') {
            const userData = JSON.parse(decodedValue);
            if (userData !== null && userData.permissions !== undefined && userData.permissions !== null) {
              return userData.permissions;
            }
          }
        } catch (e2) {}
      }
    }
    return [];
  } catch (error) {
    return [];
  }
}

function getUserRolesFromCookies() {
  try {
    if (typeof document === 'undefined') {
      return [];
    }
    if (globalState.authUsesHttpOnlyCookies !== true) {
      const jwtCookie = document.cookie.split('; ').find(row => row.startsWith('jwtToken=') != false);
      if (jwtCookie !== undefined) {
        const token = jwtCookie.split('=')[1];
        if (token !== undefined && token !== null && token !== '') {
          try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            if (Array.isArray(payload.roles) === true) {
              return payload.roles;
            }
          } catch (e1) {}
        }
      }
    }
    const userDataCookie = document.cookie.split('; ').find(row => row.startsWith('userData=') != false);
    if (userDataCookie !== undefined) {
      const cookieValue = userDataCookie.split('=')[1];
      if (cookieValue !== undefined && cookieValue !== null && cookieValue !== '') {
        try {
          const decodedValue = decodeURIComponent(cookieValue);
          if (decodedValue !== 'undefined') {
            const userData = JSON.parse(decodedValue);
            if (userData !== null && Array.isArray(userData.roles) === true) {
              return userData.roles;
            }
          }
        } catch (e2) {}
      }
    }
    return [];
  } catch (error) {
    return [];
  }
}

function refreshUserPermissions() {
  userPermissions.value = getUserPermissionsFromCookies();
  userRoles.value = getUserRolesFromCookies();
}

onMounted(async () => {
  applyVendorBrandingFromCurrentOrigin().catch(() => {});
  refreshUserPermissions();
  await nextTick();
  if (sidebarRoot.value !== null) {
    applyTranslationsToDOM(sidebarRoot.value);
  } else {
    log.error('sidebarRoot is null on mount. Translations cannot be applied.');
  }
});

watch(currentLanguage, async () => {
  log.info(`currentLanguage watcher triggered. New language: ${currentLanguage.value}`);
  await nextTick();
  if (sidebarRoot.value !== null) {
    applyTranslationsToDOM(sidebarRoot.value);
  } else {
    log.error('sidebarRoot is null in language watcher. Translations cannot be applied.');
  }
});

watch(() => [brandLogoSrc.value, globalState.whitelabel !== undefined && globalState.whitelabel !== null ? globalState.whitelabel.enabled : undefined], () => {
  logoLoaded.value = false;
  logoLoadFailed.value = false;
  logoReloadKey.value = logoReloadKey.value + 1;
}, { immediate: true });
</script>

<style scoped>
.sidebar-brand-link {
  min-height: 60px;
}

.sidebar-brand-frame {
  position: relative;
  width: 170px;
  height: 44px;
  margin-top: 1rem;
}

.sidebar-brand-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.sidebar-brand-image-hidden {
  opacity: 0;
}

.sidebar-brand-skeleton {
  position: absolute;
  inset: 0;
  border-radius: 0.75rem;
  background: linear-gradient(90deg, rgba(226, 232, 240, 0.65) 0%, rgba(241, 245, 249, 0.95) 50%, rgba(226, 232, 240, 0.65) 100%);
  animation: sidebar-brand-pulse 1.2s ease-in-out infinite;
}

@keyframes sidebar-brand-pulse {
  0% {
    opacity: 0.55;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.55;
  }
}

.nav-link {
  @apply text-gray-800 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-150 px-4 py-3 rounded-xl hover:rounded-xl;
}

.nav-link.exact-active {
   @apply bg-indigo-100 dark:bg-indigo-900 text-indigo-700 dark:text-indigo-300 font-medium rounded-xl;
}

.sidebar-ltr .nav-link {
  flex-direction: row;
}

.sidebar-ltr .nav-link > .text-xl {
  margin-left: 0;
  margin-right: 0.75rem;
}

.sidebar-ltr .text-right {
  text-align: left;
}

.sidebar-ltr .float-right {
  float: left;
}
</style>